/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrderStatusGroupVo } from './OrderStatusGroupVo';
import {
    OrderStatusGroupVoFromJSON,
    OrderStatusGroupVoFromJSONTyped,
    OrderStatusGroupVoToJSON,
    OrderStatusGroupVoToJSONTyped,
} from './OrderStatusGroupVo';

/**
 * 
 * @export
 * @interface ResponseListOrderStatusGroupVo
 */
export interface ResponseListOrderStatusGroupVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseListOrderStatusGroupVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseListOrderStatusGroupVo
     */
    message?: string;
    /**
     * 
     * @type {Array<OrderStatusGroupVo>}
     * @memberof ResponseListOrderStatusGroupVo
     */
    data?: Array<OrderStatusGroupVo>;
}

/**
 * Check if a given object implements the ResponseListOrderStatusGroupVo interface.
 */
export function instanceOfResponseListOrderStatusGroupVo(value: object): value is ResponseListOrderStatusGroupVo {
    return true;
}

export function ResponseListOrderStatusGroupVoFromJSON(json: any): ResponseListOrderStatusGroupVo {
    return ResponseListOrderStatusGroupVoFromJSONTyped(json, false);
}

export function ResponseListOrderStatusGroupVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseListOrderStatusGroupVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(OrderStatusGroupVoFromJSON)),
    };
}

export function ResponseListOrderStatusGroupVoToJSON(json: any): ResponseListOrderStatusGroupVo {
    return ResponseListOrderStatusGroupVoToJSONTyped(json, false);
}

export function ResponseListOrderStatusGroupVoToJSONTyped(value?: ResponseListOrderStatusGroupVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(OrderStatusGroupVoToJSON)),
    };
}

